module.exports = __webpack_public_path__ + "static/media/iStock-845800334.c34943c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/iStock-845800334.jpg
// module id = 684
// module chunks = 0